module.exports = __webpack_public_path__ + "img/webnew38.bde42ca7.jpg";